import { render } from "./PolitiqueRse.vue?vue&type=template&id=c43be0f6"
import script from "./PolitiqueRse.vue?vue&type=script&lang=js"
export * from "./PolitiqueRse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__